import { render, staticRenderFns } from "./RunnitsSubscriptionCardComingSoon.vue?vue&type=template&id=59a262b0&scoped=true"
import script from "./RunnitsSubscriptionCardComingSoon.vue?vue&type=script&lang=ts"
export * from "./RunnitsSubscriptionCardComingSoon.vue?vue&type=script&lang=ts"
import style0 from "./RunnitsSubscriptionCardComingSoon.vue?vue&type=style&index=0&id=59a262b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a262b0",
  null
  
)

export default component.exports